import { render, staticRenderFns } from "./icon-instagram.vue?vue&type=template&id=b30d9aea&scoped=true&"
import script from "./icon-instagram.vue?vue&type=script&lang=js&"
export * from "./icon-instagram.vue?vue&type=script&lang=js&"
import style0 from "./icon-instagram.vue?vue&type=style&index=0&id=b30d9aea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30d9aea",
  null
  
)

export default component.exports